import { Contract } from "../types";
import { StatusBadge } from "./StatusBadge";
import { ArrowRight } from "lucide-react";

export function ContractCard({
  contract,
  active,
  onClick,
}: {
  contract: Contract;
  active: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`relative text-left px-3 py-3 cursor-pointer flex flex-col gap-2 transition-colors w-full ${
        active
          ? "bg-[#FDF1E8C2] border-l-[3px] border-l-[#E2682B]"
          : "bg-white border-l-[3px] border-l-transparent"
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="text-xs font-semibold text-[#525062] flex-1 min-w-0 break-words leading-snug">
          {contract.from}{" "}
          <span className="text-[#E2682B] mx-0.5 inline-flex items-center align-middle">
            <ArrowRight className="w-2.5 h-2.5 text-[#E2682B]" />{" "}
          </span>
          {contract.to}
        </div>
        <StatusBadge status={contract.status} />
      </div>

      {!active && (
        <div className="border-t border-dashed border-[#E6E8EE] -mx-3" />
      )}

      <div className="grid grid-cols-3 gap-2 mt-0.5">
        <Metric label="Supply Period" value={String(contract.supplyPeriod)} />
        <Metric
          label="Return Period"
          value={String(contract.returnPeriod)}
          highlight
        />
        <Metric label="Banking Factor" value={contract.bf} />
      </div>
    </button>
  );
}

function Metric({
  label,
  value,
  highlight,
}: {
  label: string;
  value: string;
  highlight?: boolean;
}) {
  return (
    <div>
      <div className="text-[10px] text-[#828A99] font-medium">{label}</div>
      <div
        className={`text-[13px] font-medium mt-0.5 ${
          highlight ? "text-[#E54848]" : "text-[#525062]"
        }`}
      >
        {value}
      </div>
    </div>
  );
}

export default ContractCard;
